module.exports = __webpack_public_path__ + "static/img/product-swipe19.6bb29859.png";